var $ = require('jquery');
var _ = require('lodash');




var remove_videos = function(){
    $('.telia-video-dynamic').each(function(){
        $(this).empty()
    })

    $('.youtube-video-dynamic').each(function(){
        $(this).empty()
    })
}

var closeLight = function(){


    $('.close-away').fadeOut();
    $('.close-home').fadeOut();

    $('.video-home').fadeOut();
    $('.video-away').fadeOut();
    $('#shade').fadeOut(300,remove_videos)

    $('html').css({
        overflow: 'auto',
        height:'auto'
    });



}

var append_video = function(id){
// Check if there are containers for iframe video
if($(".telia-video-dynamic").length){
    // loop over every found container
    $(".telia-video-dynamic").each(function(){
        var event_id = $(this).attr('event_id')
        var video = $(this).attr('ind')
        // Compare parent ID to event if of container
        if(id==event_id){
            $('<iframe class="video-frame" style="position:absolute;border:0;overflow:hidden;left:0;top:0;height:100%;width:100%;" src="https://videos.liiga-services.telia.fi/embed/'+video+'?tag=Liiga.fi&hash=33d20cf099907e917ff7ac610daf66a9edfcc40e" allowfullscreen></iframe>'
            ).appendTo($(this))
        }
    });

}else if($(".youtube-video-dynamic").length){

    $(".youtube-video-dynamic").each(function(){
        var event_id = $(this).attr('event_id')
        var video = $(this).attr('ind')
        if(id==event_id){
        $(' <iframe class="video-frame" src="https://www.youtube.com/embed/'+video+'" frameborder="0" allowfullscreen></iframe>').appendTo($(this))
        }
    })
}
}


module.exports = function(){

$('.play-button-small').click(function(){
var id = $(this).attr('ind');
var team = $(this).attr('team');
append_video(id)
$('.video-frame').load(function(){
if(team == 'away'){

    $('.video-away').each(function(){
        var elem_id = $(this).attr('ind')

        if(id == elem_id){

            $(this).fadeIn();
            $('.close-away').fadeIn()
            $('html').css('overflow','hidden')
            $('#shade').fadeIn()

        }

    });
}else if(team == 'home'){

    $('.video-home').each(function(){
        var elem_id = $(this).attr('ind')
        if(id == elem_id){
            $(this).fadeIn();
            $('.close-home').fadeIn()
            $('html').css('overflow','hidden')
            $('#shade').fadeIn()

        }


    });

}
});

});

$('.close-home').on('click', closeLight);
$('.close-away').on('click', closeLight);
$('#shade').on('click', closeLight)

};



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/stats/js/light_box.js
// module id = 16
// module chunks = 0